import { render, staticRenderFns } from "./FileMediaComponent.vue?vue&type=template&id=11d73bad&"
import script from "./FileMediaComponent.vue?vue&type=script&lang=js&"
export * from "./FileMediaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports